import React, { useState, useEffect } from 'react'
import { useRecoilState } from 'recoil';
import { _programid } from '../RecoilState';
import { Link } from "react-router-dom";


const LandingProgramCard = ({ cardinfo }) => {
    const [programid, setProgramid] = useRecoilState(_programid);
    // console.log(cardinfo)

    const bgcolor = cardinfo.acf.bg_color_program
    const id = cardinfo.id

    const slug = cardinfo.slug;

    return (
        <Link to={`/programs/${slug}`} onClick={() => setProgramid(id)}>
            <div className='m-2 pt-[25px] px-[15px] pb-[10px] rounded-lg min-h-[190px]' style={{ backgroundColor: bgcolor }} >
                <div className='flex justify-center'>
                    <img src={cardinfo.acf.icon_program} width={85} alt={cardinfo.title.rendered} className='pb-[15px]' />
                </div>
                <p className='brand-font txt-bold text-[16px] leading-[18px]'>{cardinfo.title.rendered}</p>
            </div>
        </Link>
    )
}

export default LandingProgramCard